import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { AddressSearchValue } from '@qbe/dfc-smart-ui';
import { ADDRESS_FIELD_MAPS } from 'components/AddressSearch/addressHelpers';
import { AddressType } from 'components/AddressSearch/addressTypes';
import type { FormDataType } from 'contexts/FormProvider';

const useResolvedLookupAddress = (type: AddressType, form: UseFormReturn<FormDataType>) => {
  const { getValues } = form;

  const getResolvedLookupAddress = React.useCallback((): AddressSearchValue => {
    const f = ADDRESS_FIELD_MAPS[type];

    return {
      streetAddress1: (getValues(f.streetAddress) as string) ?? '',
      city: (getValues(f.suburb) as string) ?? '',
      state: (getValues(f.state) as string) ?? '',
      postcode: (getValues(f.postcode) as string) ?? '',
      country: (getValues(f.country) as string) ?? '',
      partialAddress: '',
    };
  }, [getValues, type]);

  return getResolvedLookupAddress;
};

export default useResolvedLookupAddress;
